module.exports = __webpack_public_path__ + "static/img/project-created.f1e27fd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/project-created.svg
// module id = 465
// module chunks = 0